import _get from 'lodash/get'
import reducerKey from './key'

const uiSelector = (key) => (state) => {
  return _get(state, [reducerKey, key])
}

export default uiSelector
